import { Checkbox } from "@mui/material";
import LineItemStatusChip from "./LineItemStatusChip";
import LineItemCheckbox from "./LineItemCheckbox";

const sortable = true;
export const items = [
  {},
  {
    id: "lineNumber",
    label: "Line Number",
    sortable,
  },
  {
    id: "customerName",
    label: "Customer",
  },
  {
    id: "poNumber",
    label: "PO #",
  },
  {
    id: "partNumber",
    label: "Part Number",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "dueDate",
    label: "Due Date",
    sortable,
  },
  {
    id: "status",
    label: "Status",
  },
];

export const keys = [
  {
    value: "isChecked",
    variant: "small",
    CustomComponent: LineItemCheckbox,
  },
  {
    value: "lineNumber",
  },
  {
    variant: "blueBold",
    value: "customerName",
    navigate: true,
    route: "customers",
    id: "customerId",
  },
  {
    variant: "blueBold",
    value: "poNumber",
    navigate: true,
    route: "orders",
    id: "orderId",
  },
  {
    variant: "blueBold",
    value: "partNumber",
    navigate: true,
    route: "parts",
    id: "partId",
  },
  {
    variant: "blueBold",
    value: "partName",
    navigate: true,
    route: "parts",
    id: "partId",
  },
  {
    value: "dueDate",
    isDate: true,
  },
  {
    value: "status",
    isChip: true,
    CustomComponent: LineItemStatusChip,
  },
];
